(() => {
  'use strict';
  class DisibioSearch extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('input[type=search]');
      this.panel = this.querySelector('.df-suggest');
      this.list = this.querySelector('[role=listbox]');
      this.status = this.querySelector('[role=status]');
      this.all = this.querySelector('[data-all-results]');
      this.index = -1;
      this.outside = event => { if (!this.contains(event.target)) this.close(); };
      if (this.dataset.enabled !== 'true') return;
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.index = -1;
        this.input.removeAttribute('aria-activedescendant');
        this.list.replaceChildren();
        if (this.input.value.trim().length < 2) { this.close(); return; }
        this.timer = setTimeout(() => this.search(), 180);
      });
      this.input.addEventListener('focus', () => { if (this.input.value.trim().length >= 2) this.search(); });
      this.input.addEventListener('keydown', event => this.keys(event));
      this.addEventListener('focusout', () => setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      }, 0));
      document.addEventListener('pointerdown', this.outside);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      document.removeEventListener('pointerdown', this.outside);
      this.ready = false;
    }
    close() {
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.index = -1;
    }
    async search() {
      const query = this.input.value.trim();
      if (query.length < 2) return;
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      this.list.replaceChildren();
      this.index = -1;
      this.input.removeAttribute('aria-activedescendant');
      this.status.textContent = this.dataset.loading;
      const allURL = new URL(this.querySelector('form').action);
      allURL.searchParams.set('q', query);
      this.all.href = allURL.toString();
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      const url = new URL(this.dataset.endpoint, location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product,collection');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[limit_scope]', 'all');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      url.searchParams.set('section_id', 'disibio-predictive-search');
      try {
        const response = await fetch(url, {signal:controller.signal, credentials:'same-origin'});
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        if (controller.signal.aborted || query !== this.input.value.trim()) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const results = parsed.querySelector('[data-disibio-results]');
        if (results) this.list.replaceChildren(...results.children);
        this.options().forEach((option, index) => {
          option.id = `${this.list.id}-${index}`;
          option.setAttribute('aria-selected', 'false');
        });
        this.status.textContent = this.options().length ? '' : this.dataset.empty;
      } catch (error) {
        if (error.name === 'AbortError') return;
        // The normal GET form and full-results link remain usable on failure.
        this.close();
      }
    }
    options() { return [...this.list.querySelectorAll('[data-discovery-result]')]; }
    keys(event) {
      if (event.key === 'Escape') {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.close();
        return;
      }
      if (this.panel.hidden) return;
      const options = this.options();
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && options.length) {
        event.preventDefault();
        this.index = (this.index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options.forEach((option, i) => option.setAttribute('aria-selected', i === this.index ? 'true' : 'false'));
        this.input.setAttribute('aria-activedescendant', options[this.index].id);
        options[this.index].scrollIntoView({block:'nearest'});
      } else if (event.key === 'Enter' && this.index >= 0 && options[this.index]) {
        event.preventDefault();
        options[this.index].click();
      }
    }
  }
  if (!customElements.get('disibio-search')) customElements.define('disibio-search', DisibioSearch);

  const prepareFilters = () => {
    const url = new URL(location.href);
    let active = false;
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.')) { url.searchParams.delete(key); active = true; }
    });
    url.searchParams.delete('page');
    document.querySelectorAll('[data-df-clear-filters]').forEach(link => {
      link.hidden = !active;
      link.href = url.pathname + url.search + url.hash;
    });
  };
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-df-option-search]')) return;
    const query = event.target.value.trim().toLocaleLowerCase();
    event.target.closest('.df-filter-group').querySelectorAll('li.tag').forEach(item => {
      item.toggleAttribute('data-df-hidden', !item.textContent.toLocaleLowerCase().includes(query));
    });
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-df-view-results]')) return;
    document.querySelector('#FilterDrawer .drawer__close-button')?.click();
  });
  document.addEventListener('shopify:section:load', prepareFilters);
  document.addEventListener('collection:reloaded', prepareFilters);
  window.addEventListener('popstate', prepareFilters);
  let pending;
  const observer = new MutationObserver(() => {
    clearTimeout(pending);
    pending = setTimeout(prepareFilters, 60);
  });
  const main = document.querySelector('#MainContent');
  if (main) observer.observe(main, {childList:true,subtree:true});
  prepareFilters();
})();
